<template src="./BookingEngineList.template.html"></template>
<script>
  import moment from "moment-timezone";

  export default {
    name: "bookingEngineList",
    props: [],
    data() {
      return {
        beList: [],
      };
    },

    methods: {
      redirectToDetailPage(BE_Id) {
        let vm = this;
        vm.$router.push("/bookingEngineDetail/" + BE_Id);

      },

      getBE_List() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "getBE_List",
          params: {
            ModuleAction: "getBE_List",
          },
          callback: function (err, response) {
            if (err) {
              console.log("Error in getBE_List => ", err);
              return;
            }
            if (response) {
              console.log("response in getBE_List", response);
              if (response[0]) {
                vm.beList = response[0];
              }

            }
          }
        });
      }
    },
    watch: {
    },
    computed: {
    },

    mounted() {
      let vm = this;
      vm.getBE_List();
    }
  };
</script>